import { ReactNode, createContext, useContext } from 'react'

import { Coupon, User, UserResponse } from '@infura/packages.api'
import { ServiceTier, V1Service } from '@infura/packages.uks'

import { FormBackground } from 'lib/utils/chargify'

interface CheckoutContextProps {
  user?: User
  revalidateUser: (data?: UserResponse) => void
  selectedPlan: ServiceTier
  coupon: Coupon | undefined
  couponLoading?: boolean
  currentRequestPacksQuantity: number
  setCoupon: (coupon: Coupon | undefined) => void
  formBackground: FormBackground
  showPaymentFormCancelButton?: boolean
  checkoutCloseCallback?: () => void
  requestPacksQuantity: number
  servicePlan?: V1Service
  throughputAddonEnabled: boolean
  currentThroughputAddonEnabled: boolean
}
const CheckoutContext = createContext<CheckoutContextProps>(null!)
export const useCheckoutContext = () => {
  const checkoutContext = useContext(CheckoutContext)
  if (!checkoutContext) {
    throw new Error('useCheckoutContext use outside of CheckoutContext provider')
  }
  return checkoutContext
}

export const CheckoutContextProvider = ({ children, value }: { children: ReactNode; value: CheckoutContextProps }) => {
  return <CheckoutContext.Provider value={value}>{children}</CheckoutContext.Provider>
}
